import restartChatRDPlusThemeTemplate from '../../templates/dialog/RDPlusTheme/restart_chat_template.ejs'
import restartChatTemplate from '../../templates/dialog/RDTheme/restart_chat_template.ejs'

const importEndChatOverlaySheetTemplateFactory = (options = {}) => {
    if (ApexChat.IsRoundedDynamicPlusTheme) {
        return {
            restartChatTemplate: restartChatRDPlusThemeTemplate(options),
        }
    }
    return {
        restartChatTemplate: restartChatTemplate(options),
    }

};
export default importEndChatOverlaySheetTemplateFactory;
